import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import CaseTracker from '@paypalcorp/disputes-case-tracker';
import { HcRefundsTracker } from '@paypalcorp/helpcomponents';
import { BodyText, Container, HeadingText, Link } from '@paypalcorp/pp-react';
import { MppFooterComponent, MppHeaderComponent } from './MppHeaderFooter';

// Component
import SessionHandler from '../../contactUs/containers/SessionHandler';
import HeroModuleSession from '../../contactUs/containers/HeroModule';
import NewHeroModuleSession from '../../common/HeroSectionNoLinkHome';
import ContactOptionsLinksFooter from '../../contactUs/components/ContactOptionsLinksFooter';
import AlertsContainer from '../../contactUs/containers/Alerts';
import NewSearchBox from '../../contactUs/containers/NewSearchBox';
import CustomChatBot from '../../common/customChatBotPrompt/customChatBotPrompt';
// Container
import NavHome from '../containers/NavHome';
import ModalContainer from '../../contactUs/containers/ModalContainer';
import ChatInEligibleModalContainer from '../../contactUs/containers/ChatInEligibilityModalContainer';
import StepUpContainer from '../../contactUs/containers/StepUpContainer';
import VhtwidgetContainer from '../../contactUs/containers/VhtwidgetContainer';
import DisputeAlert from '../../contactUs/containers/DisputeAlert';
import IcfContainer from '../containers/IcfContainer';
import UrlResources from '../constants/UrlResources';
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';
import ContactCardContainer from './contactOptionCards/ContactCardContainer';
import NaaAlert from '../../common/NaaAlert';
import { getCurrentRouteResourceName } from '../../lib/location-helper';
import CovidAlertModalContainer from '../../contactUs/containers/CovidAlertModalContainer';
import { isTrackersEnabledInHome } from '../../lib/covidHelper';
import { isCsHelpRefundTrackerEnabled, isDisputeTrackerEnabled } from '../../lib/TrackersHelper';
import { pageNames } from '../../lib/page-name-identifiers';
import TrackerAlerts from '../../common/trackerAlerts';
import BrexitComplaintsContainer from '../containers/BrexitComplaintsContainer';
import AustraliaComponent from '../../common/complaints/Australia/AustraliaComplaintsContainer';
import { getComplaintsPageInfo, isComplaintsCountryLocaleEnabled } from '../../lib/globalHelper';
import ContactOptionsFooter from '../../contactUs/components/complaintsEnhancedFooter/ContactOptionsLinksFooter';
import HomeApp from '../../../jsV2/home/app/App';
import QualtricsFeedbackComponent from '../../common/QualtricsFeedbackComponent';
// Innovation Guild: Search only Experiment in Help Center - import start
import { isBotExperienceEnabled, isShowOnlySearchLayoutEnabled } from '../../../experimentations/helper';
import { ContactOptionsContainer } from '../../contactUs/containers/ContactOptionsContainer';
import { CONTACT_OPTION } from '../../contactUs/constants/PropTypesShapes';

// props for channel steering
import { displayVhtWidget } from '../../contactUs/actions/action-update-user-selection';
import { locationUpdate } from '../../contactUs/actions/action-contact-location';
import { initiateRiskCheck } from '../../contactUs/actions/action-step-up';
import { loadModalContainer } from '../../contactUs/actions/action-login-modal';
import { fetchPhoneNumber } from '../../contactUs/actions/action-call-us';
import ModalCallUsContainer from '../containers/ModalCallUsContainer';
import { bannerColors, countries } from '../../common/commonConstants';
import OcpWidget from '../../common/ocpCardPrompt/OcpWidget';
import { trackLink } from '../../lib/analytics-helper';
import BrexitComplaintsDataContainer from '../containers/BrexitComplaintsDataContainer';
// Innovation Guild: Search only Experiment in Help Center - import end

const labels = {
  header: i18n.message('smarthelp/home.home.back.icf.articles'),
  homeHeader: i18n.message('smarthelp/heroSection.home.heroModule.headerLabel'),
};

class App extends Component {
  static renderRefundTracker() {
    if (isCsHelpRefundTrackerEnabled()) {
      return (
        <HcRefundsTracker
          componentName="smarthelpnodeweb"
          fptiOptions={{
            page: pageNames.refundsTrackerHome.pageName,
            pgrp: pageNames.refundsTrackerHome.pageGroupName,
          }}
          collapseAll
        />
      );
    }

    return (
      <div className="home-refund-tracker">
        <div id="refund-help" name="home" />
      </div>
    );
  }

  // Dispute Tracker
  static renderDisputeTracker() {
    const unsupportedBrowser = Page.isunSupportedBrowser();
    if (!unsupportedBrowser || isDisputeTrackerEnabled()) {
      return (
        <div className="home-dispute-tracker">
          <CaseTracker
            flow="smarthelp:home"
            fptiOptions={{
              page: 'main:help:smart::dispute-tracker:::',
              pgrp: 'main:help:smart::home',
            }}
          />
        </div>
      );
    }
    return null;
  }

  static complaintsLinkClick(urlClicked) {
    trackLink({ id: 'complaintsPage', link: `smarthelp-complaints-page-complaints-link-clicked|${urlClicked}` });
  }

  constructor(props) {
    super(props);
    this.sidebarEl = this.sidebarEl.bind(this);
    this.mainContainerEl = this.mainContainerEl.bind(this);
    this.renderSearch = this.renderSearch.bind(this);
    this.callusClicked = this.callusClicked.bind(this);
    this.state = { modalState: false };
    this.closeModal = this.closeModal.bind(this);
  }

  sidebarEl() {
    const { sideBar } = this.props;
    return <div className="side-bar side-bar__grid">{sideBar}</div>;
  }

  mainContainerEl() {
    const { mainContainer } = this.props;
    return (
      <div id="main-container" className="main-container main-container__grid" tabIndex="0" aria-label="">
        <div className="main-container-contents">{mainContainer}</div>
      </div>
    );
  }

  // Innovation Guild: Search only Experiment in Help Center
  callusClicked() {
    this.setState({ modalState: true });
    return this.props.fetchPhoneNumber();
  }

  // Innovation Guild: Search only Experiment in Help Center - import start
  closeModal() {
    this.setState({ modalState: false });
  }

  // TODO: Remove this logic during covid -19 clean up
  renderHomePageTrackers() {
    const pathName = this.props.location && this.props.location.pathname;
    const isHomePage = pathName && pathName === `/${UrlResources.HOME}`;
    // Remote Config Check for Covid-19 Enable tracker
    if (!isTrackersEnabledInHome() || !isHomePage) {
      return <div />;
    }
    return (
      <div className="trackers-home">
        {App.renderDisputeTracker()}
        {App.renderRefundTracker()}
      </div>
    );
  }

  renderHomePage() {
    const pathName = this.props.location && this.props.location.pathname;
    const icfGuides = pathName.indexOf(UrlResources.PAYPALGUIDE) !== -1;
    const isHomePage = pathName && pathName === `/${UrlResources.HOME}`;

    // Check for complaints path
    const complaintsPath = pathName && pathName.split('/') && pathName.split('/').pop() === UrlResources.COMPLAINTS;
    if (complaintsPath) {
      if (Page.getCountry() === 'au') {
        return (
          <div>
            <AustraliaComponent />
          </div>
        );
      }

      const complaintsTextInfo = getComplaintsPageInfo();

      let footerText = (
        <Container>
          <BodyText className="extended_footer_below_text">{complaintsTextInfo.complaintsFooterBelowText}</BodyText>
        </Container>
      );

      // Different footer text for country/locales in Complaints RC
      if (isComplaintsCountryLocaleEnabled()) {
        const extendedHeadingBelowText = i18n.message('smarthelp/complaints.complaintsPage.extendedHeadingBelowText');
        const extendedHeadingFinalText = i18n.message('smarthelp/complaints.complaintsPage.extendedHeadingFinalText');
        footerText = (
          <Container>
            <BodyText className="extended_footer_below_text">
              {extendedHeadingBelowText}
              <Link
                href={complaintsTextInfo.superviseDentitiesUrl}
                onClick={() => App.complaintsLinkClick(complaintsTextInfo.superviseDentitiesUrl)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {complaintsTextInfo.superviseDentitiesUrl}
              </Link>
              {extendedHeadingFinalText}
            </BodyText>
          </Container>
        );
      }
      // Add fpti tracker id
      return (
        <div>
          <AlertsContainer />
          <ModalContainer FPTITrackerId="complaintsIntermediatePage" />
          <BrexitComplaintsContainer />
          <ContactOptionsFooter />
          {Page.getCountry().toLowerCase() === countries.UK && <BrexitComplaintsDataContainer />}
          {footerText}
        </div>
      );
    }
    if (icfGuides) {
      // checking for icf or guide path to render only icfcontainer
      return (
        <div>
          <AlertsContainer />
          <IcfContainer />
          <ContactOptionsLinksFooter />
        </div>
      );
    }
    return (
      <div className="page-main-container">
        {Page.isLoggedIn() ? <TrackerAlerts /> : null}
        <DisputeAlert />
        <AlertsContainer />
        {isHomePage && <ContactCardContainer />}
        {Page.isLoggedIn() ? this.renderHomePageTrackers() : null}
        <NavHome />
        <ModalContainer FPTITrackerId="articleintermediatePage" />
        <ChatInEligibleModalContainer />
        <div className="page-body-container">
          {this.sidebarEl()} {this.mainContainerEl()}
        </div>
        {/* Rendering Custom chat bot with white banner, only if its a home page and eligible for chatbot display */}
        {pathName === '/home' && this.props.chatBotDisplay && (
          <CustomChatBot pageName="homePage" banner={bannerColors.WHITE_BANNER} />
        )}
        <ContactOptionsLinksFooter />
      </div>
    );
  }

  // Innovation Guild: Search only Experiment in Help Center - import start
  renderSeachOnlyHomePage() {
    const pathName = this.props.location && this.props.location.pathname;
    const isHomePage = pathName && pathName === `/${UrlResources.HOME}`;
    const isArticlePage = pathName && pathName.includes(`/${UrlResources.ARTICLE}/`);
    return (
      <div className="page-main-container">
        {Page.isLoggedIn() ? <TrackerAlerts /> : null}
        <DisputeAlert />
        <AlertsContainer />
        {isHomePage && <ContactCardContainer />}
        {Page.isLoggedIn() ? this.renderHomePageTrackers() : null}
        <NavHome />
        <ModalContainer FPTITrackerId="articleintermediatePage" />
        <ChatInEligibleModalContainer />
        <StepUpContainer />
        <VhtwidgetContainer />
        <div className="page-body-container">
          {!isArticlePage && this.sidebarEl()} {this.mainContainerEl()}
        </div>
        <ContactOptionsContainer
          contactChannels={this.props.contactChannels}
          fetchCallUs={this.callusClicked}
          locationUpdate={this.props.locationUpdate}
          displayVhtWidget={this.props.displayVhtWidget}
          initiateRiskCheck={this.props.initiateRiskCheck}
          loadModalContainer={this.props.loadModalContainer}
        />
        {this.props.callusData && this.props.callusData.contactInfo && (
          <ModalCallUsContainer
            state={this.state.modalState}
            closeModalFunc={this.closeModal}
            data={this.props.callusData}
          />
        )}
      </div>
    );
  }

  // eslint-disable-next-line class-methods-use-this
  renderSearch() {
    const FPTIId = Page.getFPTIPageId();
    const SearchBox = Page.isSearchTopicDisplay() ? (
      <h1 className="hero-search-header-replacement">{labels.header}</h1>
    ) : (
      <NewSearchBox FPTIId={FPTIId} />
    );
    return <div className="new-search-box-container">{SearchBox}</div>;
  }

  // eslint-disable-next-line class-methods-use-this
  renderNewHeroModule() {
    const pathName = this.props.location && this.props.location.pathname;

    // Check for complaints path
    const complaintsPath = pathName && pathName.split('/') && pathName.split('/').pop() === UrlResources.COMPLAINTS;
    // Check for home page path
    const isHomePage = pathName && pathName === `/${UrlResources.HOME}`;
    if (complaintsPath && Page.getCountry() === 'au') {
      return null;
    }

    // For UK Complaints page getting the header text from Remote Config
    if (complaintsPath && isComplaintsCountryLocaleEnabled()) {
      // Header for country/locales exists in complaints RC
      const pageHeader = i18n.message('smarthelp/complaints.complaintsPage.pageHeader');
      return (
        <NewHeroModuleSession>
          <HeadingText size="sm" theme="v2" className="complaints-header-text">
            {pageHeader}
          </HeadingText>
        </NewHeroModuleSession>
      );
    }

    if (complaintsPath && (Page.getCountry() === 'uk' || Page.getCountry() === 'gb')) {
      const pageHeader = getComplaintsPageInfo().pageHeader;
      return (
        <NewHeroModuleSession>
          <HeadingText size="sm" theme="v2" className="complaints-header-text">
            {pageHeader}
          </HeadingText>
        </NewHeroModuleSession>
      );
    }

    if (!Page.isContactUsPage()) {
      return (
        <NewHeroModuleSession>
          <div className="homepage-search">
            <HeadingText size="sm" theme="v2" className="header-text">
              {labels.homeHeader}
            </HeadingText>
            <div className="homepage-search-bottom">
              {isHomePage && <OcpWidget pathName="home" />}
              {this.renderSearch()}
            </div>
          </div>
        </NewHeroModuleSession>
      ); // New Hero Module
    }
    return <HeroModuleSession />; // Existing Hero Module
  }

  // Complaints Page Header Image
  renderBrexitHeaderIcon() {
    const pathName = this.props.location && this.props.location.pathname;

    // Check for complaints path
    const complaintsPath = pathName && pathName.split('/') && pathName.split('/').pop() === UrlResources.COMPLAINTS;

    if (complaintsPath && (Page.getCountry() === 'uk' || isComplaintsCountryLocaleEnabled())) {
      return <div className="brexit-complaints-page__intro-icon" />;
    }

    return <div />;
  }

  // Innovation Guild: Search only Experiment in Help Center
  // add renderHome function to render, for experiment or control group
  renderHome() {
    if (isShowOnlySearchLayoutEnabled() || isBotExperienceEnabled()) {
      return this.renderSeachOnlyHomePage();
    }
    return this.renderHomePage();
  }

  render() {
    const pathName = getCurrentRouteResourceName(this.props.location);
    if (pathName === UrlResources.HOME_V2) {
      return <HomeApp>{this.props.mainContainer}</HomeApp>;
    }

    return (
      <div>
        <MppHeaderComponent />
        <div className="vx_mainContent" role="main">
          <SessionHandler />
          {this.renderNewHeroModule()}
          {this.renderBrexitHeaderIcon()}
          <div className="page-main-container">
            {Page.isLoggedIn() ? <NaaAlert pathName={pathName} /> : <div />}
            <CovidAlertModalContainer location={this.props.location} />
            {this.renderHome()}
            <QualtricsFeedbackComponent />
          </div>
        </div>
        <MppFooterComponent />
      </div>
    );
  }
}

App.propTypes = {
  sideBar: PropTypes.element.isRequired,
  mainContainer: PropTypes.element.isRequired,
  location: PropTypes.string.isRequired,
  // Innovation Guild: Search only Experiment in Help Center - App.propTypes start
  contactChannels: PropTypes.arrayOf(PropTypes.shape(CONTACT_OPTION)),
  fetchPhoneNumber: PropTypes.func.isRequired,
  locationUpdate: PropTypes.func.isRequired,
  displayVhtWidget: PropTypes.func.isRequired,
  initiateRiskCheck: PropTypes.func.isRequired,
  loadModalContainer: PropTypes.func.isRequired,
  chatBotDisplay: PropTypes.bool.isRequired,
  callusData: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  // Innovation Guild: Search only Experiment in Help Center - App.propTypes end
};

function mapStateToProps(state) {
  return {
    location: state.location,
    contactChannels: state.contactChannels.channels,
    callusData: state.callUs.callUsResult,
    chatBotDisplay: state.postChatBotEligibility.chatBotDisplay,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      displayVhtWidget,
      locationUpdate,
      initiateRiskCheck,
      loadModalContainer,
      fetchPhoneNumber,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
